import { useEffect, useRef, useState } from 'react';


export const Typewriter = ({
    items = [],
    renderItem,
    onComplete,
    delay = 1000,
    className = ''
}) => {
    const [visibleItems, setVisibleItems] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const timeoutRef = useRef(null);

    useEffect(() => {
        if (currentIndex < items.length) {
            timeoutRef.current = setTimeout(() => {
                setVisibleItems(prev => [...prev, items[currentIndex]]);
                setCurrentIndex(prev => prev + 1);
            }, delay);
        } else if (onComplete) {
            onComplete();
        }

        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, [currentIndex, items, delay, onComplete]);

    if (!Array.isArray(items) || items.length === 0) {
        return null;
    }

    return (
        <div className={className}>
            {visibleItems.map((item, index) => (
                <div key={index} style={{ marginBottom: '8px' }}>
                    {renderItem ? renderItem(item, index) : String(item)}
                </div>
            ))}
        </div>
    );
};
